export const WEB_VERSION = "0.4";
export const USER_ADMIN = 'admin-users';
// Events
export const EVENT_RESET_PASSWORD_EMAIL = 'reset-password-data-email';
export const EVENT_SIGN_UP_EMAIL = 'sign-up-data-email';
// Product
export const IP150_LENGTH = 17;
export const RANGE_MAX = 1000;
// Config AWS
// uncomment  this ENV_CONFIG for live build!
export const  ENV_CONFIG = {
    api_url :     'https://hz7bbp44di.execute-api.eu-west-1.amazonaws.com/access_point',
    api_key :    "DSdT30fA6352442a9P914jd20iNb8b3aAc5o54ZQ",
};